import camelcaseKeys from 'camelcase-keys'

import Member, { MemberPermissions, Progression } from '@src/data/member'
import { Club } from '@src/routes/club/club'
import { HealthLimitationSet } from '@src/data/health-limitation-set'
import WorkoutData from '@src/data/workout-data'
import TrainingPlan from '@src/data/training-plan'
import { MetricData } from '@src/data/body-measurement'

type TrainingStatus = { id: number, key: string, type: string, value: number }

export class MemberProfile extends Member {

  metrics: any = {}
  goals: any = {}
  bodyWeightNotes: string = ''
  bodyCircumferenceNotes: string = ''
  bloodPressureNotes: string = ''
  avatarOriginalUrl: string = ''
  avatar: object

  healthLimitationsSet: HealthLimitationSet
  trainingGoals
  trainingStatus: { [key: string]: number }[] = []
  club: Club

  constructor (attributes?) {
    super(attributes)
    Object.assign(this, attributes)
    if (attributes) {
      // member specifics
      if (attributes.progression) {
        this.progression = new Progression(camelcaseKeys(attributes.progression, { deep: true }))
      }
      if (attributes.activeWorkout) {
        this.activeWorkout = new WorkoutData(camelcaseKeys(attributes.activeWorkout, { deep: true }))
      }
      if (attributes.homeWorkout) {
        this.homeWorkout = new WorkoutData(camelcaseKeys(attributes.homeWorkout, { deep: true }))
      }
      if (attributes.currentTrainingPlan) {
        this.currentTrainingPlan = new TrainingPlan(camelcaseKeys(attributes.currentTrainingPlan, { deep: true }))
      }
      if (attributes.memberPermissions) {
        this.memberPermissions = new MemberPermissions(camelcaseKeys(attributes.memberPermissions, { deep: true }))
      }
      if (attributes.usualStartTimes) {
        this.usualStartTimes = attributes.usualStartTimes.sort((a, b) => a - b)
      }

      // body measurements
      this.bodyWeightNotes = attributes.bodyWeightNotes
      this.bodyCircumferenceNotes = attributes.bodyCircumferenceNotes
      this.bloodPressureNotes = attributes.bloodPressureNotes
      this.avatarOriginalUrl = attributes.avatarOriginalUrl
      this.avatar = attributes.avatar

      if (attributes.bodyMeasurements) {
        attributes.bodyMeasurements.forEach(metric => {
          this.metrics[metric.name] = metric.data.map(data => new MetricData(camelcaseKeys(data, { deep: true })))
        })
      }

      if (attributes.bodyMeasurementGoals) {
        attributes.bodyMeasurementGoals.forEach(metric => {
          this.goals[metric.name] = metric.data.map(data => new MetricData(camelcaseKeys(data, { deep: true })))
        })
      }

      // training status
      if (attributes.trainingStatus) {
        attributes.trainingStatus.forEach((entry: TrainingStatus) => {
          // training status values are between 1 and 50 => multiplied by two, they become a percentage
          this.trainingStatus[entry.key] = entry.value * 2
        })
      }

      // health limits
      if (attributes.healthLimitationsSet) {
        this.healthLimitationsSet = new HealthLimitationSet(camelcaseKeys(attributes.healthLimitationsSet, { deep: true }))
      }
    }
  }
}
